<mat-sidenav-container [hasBackdrop]="false" class="h-full w-full">
  <mat-sidenav-content class="h-full">
    <ng-content></ng-content>
  </mat-sidenav-content>

  <mat-sidenav [mode]="'side'" [opened]="state.sidebarOpen" [position]="'end'" class="w-[400px]">
    <ng-content select="[y42NamedRouterOutlet]"></ng-content>
  </mat-sidenav>
</mat-sidenav-container>
